import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-filter",
  "use": "foquz-icon-filter-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol viewBox=\"0 0 11 11\" fill=\"none\" id=\"foquz-icon-filter\"><path d=\"M10.512.25H1.469c-.43 0-.645.508-.332.8L4.75 4.665v4.024c0 .156.059.312.195.39l1.563 1.094c.312.215.742 0 .742-.39v-5.12l3.594-3.613c.312-.293.097-.801-.332-.801z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol